import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ResetPassword = React.lazy(
  () => import('components/User/ResetPassword/ResetPassword'),
);

const cbn = 'reset-password';

function ScreensUserResetPassword() {
  return (
    <BaseLayout className={`${cbn}__window`}>
      <div className="reset-password__wrapper ">
        <DocumentTitle>Reset Your Password</DocumentTitle>
        <UIPageTitle>Reset password</UIPageTitle>
        <Suspense fallback={<UILoader />}>
          <ResetPassword />
        </Suspense>
      </div>
    </BaseLayout>
  );
}

export default ScreensUserResetPassword;
